import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import * as _moment from 'moment';
import { Router } from '@angular/router';
import { AppointmentsService } from 'app/modules/doctors-view/services/appointments.service';
import { Citasview } from 'app/modules/doctors-view/entities/citasview';
import { EmployeeService } from '../../employee/services/employee.service';
import Utils from 'app/Utils';

const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

export interface PeriodicElement {
  name: string;
  position: number;
  weight: number;
  symbol: string;
}

const ELEMENT_DATA: PeriodicElement[] = [
  { position: 1, name: 'Hydrogen', weight: 1.0079, symbol: 'H' },
  { position: 2, name: 'Helium', weight: 4.0026, symbol: 'He' },
  { position: 3, name: 'Lithium', weight: 6.941, symbol: 'Li' },
  { position: 4, name: 'Beryllium', weight: 9.0122, symbol: 'Be' },
  { position: 5, name: 'Boron', weight: 10.811, symbol: 'B' },
  { position: 6, name: 'Carbon', weight: 12.0107, symbol: 'C' },
  { position: 7, name: 'Nitrogen', weight: 14.0067, symbol: 'N' },
  { position: 8, name: 'Oxygen', weight: 15.9994, symbol: 'O' },
  { position: 9, name: 'Fluorine', weight: 18.9984, symbol: 'F' },
  { position: 10, name: 'Neon', weight: 20.1797, symbol: 'Ne' },
];

@Component({
    selector: 'app-appointments',
    templateUrl: './appointments.component.html',
    styleUrls: ['./appointments.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
    ],
    standalone: false
})
export class AppointmentsComponent implements OnInit {
  currentUser: any;
  permissionList = [];
  currentServiceDate: Date = new Date();
  empressaId: any;
  CitasDta: Citasview;
  medicoViwData: any = [];
  date = new UntypedFormControl(moment());
  displayedColumns: string[] = ['position', 'name', 'weight', 'symbol'];
  dataSource = ELEMENT_DATA;
  empresaId: any;

  constructor(
    private router: Router,
    public appointmentService: AppointmentsService,
    private dateAdapter: DateAdapter<any>,
    private employeeService: EmployeeService) {
  }

  ngOnInit(): void {
    this.currentUser = JSON.parse(Utils.decrypt(localStorage.getItem('currentUser'))) ;
    this.CitasDta = new Citasview();
    if (this.currentUser) {
      this.permissionList = this.currentUser.permissionIds;
    }
    this.getServiceDate(this.currentServiceDate, true);
    this.setSpain();
  }

  setSpain(): void {
    this.dateAdapter.setLocale('es');
  }

  goToagenda(): void {
    this.router.navigate(['/agenda']);
  }

  getServiceDate(serviceDate, isShift?): void {
    this.appointmentService.isLoading = true;
    if (isShift === undefined) {
      this.currentServiceDate = new Date(serviceDate._d);
    }

    this.empressaId = JSON.parse(localStorage.getItem('Empresa'));
    this.CitasDta.EmpresaId = this.empressaId;
    this.CitasDta.date = moment(this.currentServiceDate).format('YYYY/MM/DD');
    if (this.empressaId != null) {
      this.appointmentService.getAppointmentsServiceData(this.CitasDta).then(
        res => {
          this.appointmentService.isLoading = false;
        }
      ).catch(
        res => {
          console.error(res);
          this.appointmentService.isLoading = false;
        }
      );
    }

  }

  nextDate(): void {
    this.currentServiceDate = new Date(this.currentServiceDate.setDate(this.currentServiceDate.getDate() + 1));
    this.getServiceDate(this.currentServiceDate, true);
  }

  previousDate(): void {
    this.currentServiceDate = new Date(this.currentServiceDate.setDate(this.currentServiceDate.getDate() - 1));
    this.getServiceDate(this.currentServiceDate, true);
  }

  UserClicked(task): void {
    this.employeeService.userSelectedappointment(task);
  }
}
